<template>
    <v-toolbar color="amber" app absolute clipped-left height="40">
        <v-toolbar-side-icon class="white--text" v-if="aside" @click.native="$emit('input', !value)"></v-toolbar-side-icon>

        <div class="white--text session__title">Онлайн оценка компетенций взрослого населения</div>
        <v-flex></v-flex>
        <v-btn class="session__quit white--text" @click="quitDialog = true" flat small>Выйти</v-btn>

        <v-dialog v-model="quitDialog" width="500">
            <v-card>
                <v-card-text>Вы действительно хотите выйти из системы?</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="quitDialog = false">Отмена</v-btn>
                    <v-btn color="primary" @click="logout">Выйти</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-toolbar>
</template>

<script>
    export default {
        components: {},
        data () {
            return {
                quitDialog: false
            }
        },
        props: {
            aside: Boolean,
            value: Boolean
        },
        computed: {},
        methods: {
            logout () {
                this.quitDialog = false
                this.$store.dispatch('auth/logout')
                this.$router.push({name: 'main'})
            }
        }
    }
</script>

<style lang="stylus">
    .amber {
        color: #fff;
        background: linear-gradient(to right, #2f75be 0%, #2f75be 50%, #8f8f8f 100%);
    }
    .session__quit {
        margin 0 2.5rem
        font-size 1rem
        .icon {
            margin-left 5px
        }
    }
    .session__title {
        padding-left 15px
    }
</style>
